import {cs}                from "@Common/react/chain-services";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";
import {omit}              from "@Common/utils/objects";

export const AddressableShippingQuantityLogic = ({item, next: rootNext}) => cs(

    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            item?.blankQty,

            (quantity) => ({
                saved  : quantity,
                current: quantity,
            }),
        ),
        next,
    })],
    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, [], (_) => omit(_, ["blankQty"])),
        next,
    })],

    ({state, step1}) => {

        const quantity = !state.value.current ? 0 : +state.value.current;
        return step1.next({
            totalQuantity: quantity,

            itemEditor: {
                $name: "addressable shipping",
                changed: state.value.saved !== state.value.current,

                prepareSave: (item) => ({
                    newValue: changeNestedValue(item, ["blankQty"], (_) => quantity ? ""+quantity : ""),
                    onSaved: () => setCurrentToSaved(state),
                }),

                valid: quantity>=0,
            },
            ui: scopedState(state, ["current"]),
        });
    },
);

